module.exports = __webpack_public_path__ + "img/icon-facebook.f33c7269.svg";